/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Contact } from '../../../core/models/common/Contact';
import { License } from '../../../core/models/common/License';
import { OasInfo } from '../../models/OasInfo';
import { Oas20Contact } from './Oas20Contact';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { Oas20License } from './Oas20License';

/**
 * Constructor.
 * @class
 * @extends OasInfo
 * @author eric.wittmann@gmail.com
 */
export class Oas20Info extends OasInfo {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Info#createContact()
     * @return {Contact}
     */
    public createContact() : Contact {
        let contact : Contact = new Oas20Contact();
        contact._ownerDocument = this.ownerDocument();
        contact._parent = this;
        return contact;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Info#createLicense()
     * @return {License}
     */
    public createLicense() : License {
        let license : License = new Oas20License();
        license._ownerDocument = this.ownerDocument();
        license._parent = this;
        return license;
    }
}
Oas20Info["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Info";
Oas20Info["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




